import { TypographyProps } from "@mui/material/Typography";

type FontVariant = {
  [key in "small" | "medium"]: TypographyProps["variant"];
};

const componentStyle = {
  padding: {
    small: [0.75, 2],
    medium: [0.8, 2],
  },
  fontVariant: {
    small: "caption",
    medium: "body3",
  } as FontVariant,
};

export const useGetGainLossStyles = () => componentStyle;
